import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { SecureLinkAchFormStore } from '../stores';

/** The public app's achFormStore, typed as the secure link store (the page needs setRequest). */
export const useSecureLinkAchFormStore = () =>
  useContext<{
    achFormStore: SecureLinkAchFormStore;
  }>(StoreContext);
